"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const faqs = [{
    id: 1,
    question: "What subjects do you offer tutoring in?",
    answer: "We provide tutoring in KS3 and GCSE Science (all levels), Maths (up to GCSE), English, and 11+ exam preparation. Each session is tailored to the student's needs and learning pace."
  }, {
    id: 2,
    question: "What are the different programmes available?",
    answer: "We offer a 30-Day Introductory Programme for foundational confidence, a 12-Week Improvement Programme for deeper subject mastery, and a 12-Month Full Mastery Package for year-round support. We also provide flexible pay-per-lesson options."
  }, {
    id: 3,
    question: "How does the confidence coaching work?",
    answer: "Our confidence coaching focuses on mindset, focus, motivation, time management, and exam techniques. It runs alongside academic tutoring to help students develop resilience, positive study habits, and a growth-oriented approach to learning."
  }, {
    id: 4,
    question: "Are sessions conducted online?",
    answer: "Yes, all sessions are delivered online via secure video conferencing. This allows for flexible scheduling and ensures students can learn comfortably from home while still receiving expert, personalised support."
  }, {
    id: 5,
    question: "How do I book a free consultation?",
    answer: "You can book a free consultation by clicking the 'Book a Free Consultation' button on our website, or by contacting us directly at 0800 123 4567 or contact@educationfamilytutors.co.uk. We'll discuss your child's needs and recommend the best programme."
  }, {
    id: 6,
    question: "What qualifications do your tutors have?",
    answer: "All our tutors are UK-qualified teachers with extensive experience in tutoring KS3 and GCSE students. They specialise in both academic instruction and confidence coaching, ensuring holistic support for every learner."
  }];
  return <section ref={ref} className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className={`mb-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <h2 className="font-display text-primary mb-4 text-3xl font-bold sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-base sm:text-lg">
            Find answers to common questions about our tutoring programmes,
            coaching approach, and how we support students in achieving their
            goals.
          </p>
        </div>

        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Accordion type="single" collapsible className="bg-background rounded-lg shadow-soft">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="border-border px-6 transition-all duration-[var(--duration-fast)] ease-in-out hover:bg-primary-light/30">
                <AccordionTrigger className="text-foreground py-5 text-left font-semibold hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}